import {getDataWithPromise} from "root/DataFunctions/BaseDataFns";


export const getFutureAbsencesForSchool = (school_id, filter, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/schools/' + school_id + '/futureabsence?filter=' + filter;

    return getDataWithPromise(url, 'GET')
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getFutureAbsenceForId = (longTermAbsenceId, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/absence/longterm/' + longTermAbsenceId;

    return getDataWithPromise(url, 'GET')
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const createFutureAbsenceForPupil = (long_term_absence_id, formData, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/absence/longterm/' + long_term_absence_id;

    return getDataWithPromise(url, 'POST', {formData})
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const editFutureAbsenceById = (longTermAbsenceId, formData, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/absence/longterm/' + longTermAbsenceId;

    return getDataWithPromise(url, 'PUT', {formData})
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const deleteFutureAbsenceById = (longTermAbsenceId, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/absence/longterm/' + longTermAbsenceId;

    return getDataWithPromise(url, 'DELETE')
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

